import { SearchPageContainer } from './styles';

export default SearchPageContainer;
